var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stage-card-info-list',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("Trend")]},proxy:true},{key:"content",fn:function(){return [_c('screening-trend-breakdown',{attrs:{"review":_vm.review}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }